import { assign, createMachine } from "xstate";

import { ProductImportRst } from "../types/product";

interface ProductImagesImportContext {
  files: FileList;
  filesProgress: { name: string; progress: number };
  rst: ProductImportRst[];
}

const assignProductImages = assign({
  files: (context, event: any) => event.files,
  filesProgress: (context, event: any) => event.filesProgress,
});

const assignRst = assign({
  rst: (context, event: any) => event.rst,
});

export const productImageImportMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QAcBOB7CBXAxgFwEkBbZdVPAOgEsA7KvAYgGUBRAGRYGEAVAfQDECHANoAGALqIU6WPSroaUkAA9EARgDMoigDYArAA4DetToBMGvZdMAaEAE91GtRQCcAdj1m97g+8vWOgC+QXZomLiEJGSUADZUsIwAqgAKbADyAIIAImKSSCCksnjyigWqCBoGACwUojoa7q46rh6i7qIado4IatWuFGqt+mqiBhZ6Op4hYRjY+MSk5BTxiQwAQpmcANJ5SkVyCkoVQ3pu9d7diAYu1cZThmpq7g8GM4VzkYsxFFjIsegAIYQWhQBicdIAWTSLG4LFyEn2MkOZVAFQatT0Xna9WeryuvTMOgoGlcGh0OjGDTM1VEkxCoRANEwcH2nwW0XISOKpWOiAAtDoCYL3uF5lElpRaPRuSi+QhqmYCX13INhiYxhMHqL2RKfqs8LKSkdyogtNpaf1qlZ-FYTEKHOp+rp1aNxpZtYyxV9OZQ-gDgaCjbzTQg9GMKF5Wo13NVqn16srnS1mhr3ZNpl7dd9ljh0CRYmA8JBgya0Ygmi5Ojo45M8Z4DEmBimRpqPZmQkA */
    id: "productImport",
    initial: "init",
    predictableActionArguments: true,
    schema: {
      context: {} as ProductImagesImportContext,
    },
    context: {
      files: null as any,
      filesProgress: null as any,
      rst: null as any,
    },
    states: {
      init: {
        on: {
          SELECT_FILE: {
            target: "list",
            actions: ["assignProductImages"],
          },
        },
      },
      list: {
        on: {
          UPLOAD: {
            target: "uploading",
          },
          BACK: {
            target: "init",
          },
        },
      },
      uploading: {
        on: {
          COMPLETED: {
            target: "completed",
            actions: ["assignRst"],
          },
        },
      },
      completed: {},
    },
  },
  {
    actions: { assignProductImages, assignRst },
  }
);
